import RaisedButton from 'material-ui/RaisedButton';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';

import { renderInput } from 'src/components/misc/redux-form-helpers';
import { SanitizedInnerHTML } from 'src/common';

class LoginForm2FA extends Component {
    render() {
        const { t, handleSubmit, hasError, statusOnly } = this.props;
        const noWhitespace = value => value && value.replace(/\s/g, '');
        return (
            <>
                <form className="form-horizontal" onSubmit={handleSubmit}>
                    <div className="col-xs-12 col-md-12">
                        <div className="form-group"></div>
                        {!statusOnly && (
                            <>
                                {hasError && <div className="alert alert-danger">{t('login_code_error')}</div>}
                                <p>
                                    <SanitizedInnerHTML html={this.props.t('tfa.info')} />
                                </p>
                                <div className="form-group">
                                    <div className="col-xs-12">
                                        <Field
                                            name="code"
                                            type="text"
                                            normalize={noWhitespace}
                                            label={t('common_phrases.code')}
                                            component={renderInput}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="col-xs-12">
                                        <RaisedButton
                                            primary={true}
                                            type="submit"
                                            label={t('login_information.login')}
                                            className="pull-right"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </form>
            </>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    if (!values.code) errors.code = t('error_missing.fill_in_tfa_code');

    return errors;
};

export default withTranslation()(
    reduxForm({
        form: 'loginForm2fa',
        validate,
    })(LoginForm2FA),
);
